import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { styled, alpha } from "@mui/material/styles";
import {
  white,
  fadeBlueWhite,
  textPrimaryColor,
  grayShadeWithSoftBlue,
  secondaryMainColor,
  slateBorderHoverColor,
  defaultInputBorderColor,
} from "../config/ColorObj";

const Search = styled("div", {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ theme, variant }) => ({
  position: "relative",
  borderRadius: variant === "light" ? 8 : theme.shape.borderRadius,
  width: "100%",
  ...(variant === "light"
    ? {
        backgroundColor: white,
        border: `1px solid ${fadeBlueWhite}`,
        boxShadow: `0 1px 2px ${alpha(textPrimaryColor, 0.04)}`,
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          borderColor: slateBorderHoverColor,
        },
        "&:focus-within": {
          borderColor: secondaryMainColor,
          boxShadow: `0 0 0 3px ${alpha(secondaryMainColor, 0.1)}`,
        },
      }
    : {
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        marginRight: theme.spacing(2),
        marginLeft: 0,
        "&:hover": {
          backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        [theme.breakpoints.up("sm")]: {
          marginLeft: theme.spacing(3),
          width: "auto",
        },
      }),
}));

const SearchIconWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ theme, variant }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: variant === "light" ? grayShadeWithSoftBlue : "inherit",
}));

const StyledInputBase = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ theme, variant }) => ({
  color: variant === "light" ? textPrimaryColor : "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: variant === "light" ? "10px 12px 10px 0" : theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    fontSize: variant === "light" ? 13 : "inherit",
    ...(variant === "light"
      ? {
          border: "none",
          borderRadius: 8,
          "&::placeholder": {
            color: grayShadeWithSoftBlue,
            opacity: 1,
          },
        }
      : {
          [theme.breakpoints.up("md")]: {
            width: "20ch",
          },
          border: `1px solid ${defaultInputBorderColor}`,
          borderRadius: "5px",
        }),
  },
}));

const SearchBar = ({
  filteredRows,
  searchValue,
  placeHolder = "Search",
  variant = "default",
  sx,
}) => {
  return (
    <Search variant={variant} sx={sx}>
      <SearchIconWrapper variant={variant}>
        <SearchIcon fontSize={variant === "light" ? "small" : "medium"} />
      </SearchIconWrapper>

      <StyledInputBase
        variant={variant}
        placeholder={placeHolder}
        inputProps={{ "aria-label": "search" }}
        onChange={(searchVal) => filteredRows(searchVal.target.value)}
        value={searchValue}
      />
    </Search>
  );
};
export default SearchBar;
